var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAppStore = function SvgAppStore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 19,
    fill: "currentColor",
    viewBox: "0 0 16 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.747 10.176a4.001 4.001 0 0 1 1.915-3.364 4.113 4.113 0 0 0-3.243-1.748c-1.364-.143-2.687.814-3.382.814-.71 0-1.78-.8-2.932-.776a4.327 4.327 0 0 0-3.634 2.21c-1.572 2.713-.4 6.7 1.106 8.892.753 1.074 1.633 2.274 2.785 2.231 1.126-.046 1.547-.716 2.908-.716 1.347 0 1.742.716 2.917.69 1.21-.02 1.971-1.08 2.698-2.163a8.872 8.872 0 0 0 1.234-2.506 3.867 3.867 0 0 1-2.372-3.564ZM10.524 3.623A3.94 3.94 0 0 0 11.43.795 4.031 4.031 0 0 0 8.824 2.14a3.754 3.754 0 0 0-.93 2.723 3.338 3.338 0 0 0 2.63-1.24Z"
  })));
};
export default SvgAppStore;